import { render, staticRenderFns } from "./InterphonesSelect.vue?vue&type=template&id=dd1660a0&scoped=true"
import script from "./InterphonesSelect.vue?vue&type=script&lang=js"
export * from "./InterphonesSelect.vue?vue&type=script&lang=js"
import style0 from "./InterphonesSelect.vue?vue&type=style&index=0&id=dd1660a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1660a0",
  null
  
)

export default component.exports